/**
 * This taste need the implementation of 'createHTML' method, tipically done using HTMLDialogFactory
 */
hrd.AbstractHTMLFormPopup = hrd.AbstractFormPopup.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.AbstractHTMLFormPopup'
		};
		this._super(undefined, $.extend({}, defaults, options));
		this.dialogFactory = this.createHTMLFactory();
		this.$dialog = this.dialogFactory.create();
		this.DIALOG_ID = '#' + this.$dialog.attr('id');
	},
	createHTMLFactory: function(){
		this.__abstractMethod__(arguments.callee);
	}
});